import React from 'react';
import OutputLine from "./OutputLine";
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import IconMenuItemOutput from "./IconMenuItemOutput";

const propTypes = {
	indentLevel: PropTypes.number.isRequired,
	isHighlighted: PropTypes.bool,
	menu: PropTypes.arrayOf(PropTypes.object).isRequired,
};
const defaultProps = {
	isHighlighted: false,
};

const MenuListOutput = ({indentLevel, isHighlighted, menu}) => {
	return (
		(menu && menu.length) ?
			menu
				.filter((menuItem) => (menuItem.children.length > 0 || menuItem.onClick || menuItem.icon || menuItem.iconType || menuItem.open || menuItem.openInNewTab || menuItem.selected || menuItem.text || menuItem.url))
				.map((menuItem, i, a) => (
					<div key={menuItem.id}>
						<OutputLine indent={indentLevel} highlightableField={menuItem.id}>
							{`{`}
						</OutputLine>
						<IconMenuItemOutput indentLevel={indentLevel} menuItem={menuItem}/>
						<OutputLine indent={indentLevel} highlightableField={menuItem.id}>
							{`},`}
						</OutputLine>
					</div>
				)) : null
	);
};

MenuListOutput.propTypes = propTypes;
MenuListOutput.defaultProps = defaultProps;

export default observer(MenuListOutput);
